import { ChangeEvent, FormEvent, FormEventHandler } from 'react'

export const SUPABASE_API_URL = 'https://hnutigzbhbiimhebcfgl.supabase.co'
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhudXRpZ3piaGJpaW1oZWJjZmdsIiwicm9sZSI6ImFub24iLCJpYXQiOjE2Njk2Mzk3MTAsImV4cCI6MTk4NTIxNTcxMH0.muL7evqzTRnAyBcmaPuvrF0s5oAirCL3UBsm1ofbzCw'
export const SUPABASE_OPTIONS = {
  db: {
    schema: 'public',
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    // headers: { 'x-my-custom-header': 'my-app-name' },
  },
}

export const DOMAIN = 'backupdiary.com'

export const PATHS = {
  ID: '/id/',
  HOME: '/notes',
  ACCOUNT: '/account',
  NOTE_INDEX: '/notes',
  NEW_NOTE: '/notes/new',
  AFTER_SIGN_OUT: '/id/',
  ID_VERIFY: '/id/verify',
  SINGLE_NOTE_INDEX: '/notes/',
}

export const topNavLinks = [
  { name: 'Notes', href: PATHS.NOTE_INDEX },
  { name: 'Your Account', href: PATHS.ACCOUNT },
]

export type ChangeInput = ChangeEvent<HTMLInputElement>
export type SubmitForm = FormEvent

export const MAX_RECIPIENTS = 5

export const MAX_INPUT_LENGTH = {
  PHONE: 20,
  EMAIL: 255,
  NOTE_NAME: 40,
  USER_FULL_NAME: 30,
  PERSONAL_MESSAGE: 1000,
}

export const GRACE_PERIOD = 7

export const H_CAPTCHA_SITE_KEY = '82c91366-9080-4046-b6ee-06938039a700'

export const STRIPE_PAYMENT_IDS: Record<string, string> = {
  payment: process.env.STRIPE_ONETIME as string,
  subscription: process.env.STRIPE_YEARLY as string,
}

export const DEFAULT_SEND_EVENT_DAYS = 60

export const SENTRY_SAMPLE_RATE = process.env.SENTRY_SAMPLE_RATE ?? 1.0 // what percentage of actions should be logged. all in the dev.
